var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "解决 (状态修改为已解决 并指派给创建人)",
        visible: _vm.dialogVisibleSolve,
        width: "60%",
        "before-close": _vm.handleCloseSolve,
        "close-on-press-escape": false,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisibleSolve = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "solve",
          attrs: { model: _vm.solve, inline: true, "label-width": "80px" }
        },
        [
          _c(
            "el-form-item",
            {
              staticClass: "solve_summernote_item",
              attrs: { label: "回复工单" }
            },
            [
              _c("EditorSummernote", {
                ref: "summernote_3",
                attrs: { id: "solve_summernote" },
                model: {
                  value: _vm.solve.content,
                  callback: function($$v) {
                    _vm.$set(_vm.solve, "content", $$v)
                  },
                  expression: "solve.content"
                }
              }),
              _vm._v(" "),
              _c("TicketUploadList", {
                ref: "upList2",
                on: {
                  clear: function() {
                    this$1.$refs.up5.clearFile()
                  },
                  delete: function(e) {
                    this$1.$refs.up5.deleteFile(e)
                  }
                }
              }),
              _vm._v(" "),
              _c("TicketUpload", {
                ref: "up5",
                attrs: { ticketUploadList: _vm.$refs.upList2 }
              }),
              _vm._v(" "),
              _c("TicketTemplateSelect", {
                on: { selected: _vm.onTicketTemplateSelected }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleCloseSolve } }, [
            _vm._v("取消")
          ]),
          _vm._v(" "),
          _c("SubmitTicketButton", {
            ref: "solveBtn_1",
            attrs: { buttonText: "提交" },
            on: { click: _vm.solveOrder }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28aa9130", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28aa9130","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketSolveDialog.vue
// module id = 792
// module chunks = 75